<template>
    <div>
        <v-container fluid pa-0>
            <!-- <v-progress-linear
                v-for="(i, index) in 3"
                :key="index"
                :active="true"
                :indeterminate="component_loader && index == 2"
                color="primary"
                class="my-0"
                style="height: 2px !important"
            ></v-progress-linear> -->
            <v-card elevation="0">
                <v-card-text :class="notifications && notifications.length == 0 ? 'pl-0' : null">
                    <v-layout row wrap>
                        <v-flex xs12 lg3>
                            <v-card-text class="pa-0">
                                <v-list two-line>
                                    <vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : 'height: calc(100vh - 340px)'">
                                        <template v-for="(notification, index) in notifications">
                                            <v-list-tile
                                                :style="{
                                                    backgroundColor:
                                                        selectedNotification && selectedNotification.notification_id == notification.notification_id
                                                            ? '#dde6f3'
                                                            : '',
                                                    borderBottom: '1px solid #ddd',
                                                    cursor: 'pointer',
                                                }"
                                                @click="selectNotification(notification)"
                                            >
                                                <v-list-tile-action>
                                                    <v-icon :color="notification.icon_class">{{ notification.icon }}</v-icon>
                                                </v-list-tile-action>

                                                <v-list-tile-content>
                                                    <v-list-tile-title :class="[notification.read_flag == 0 ? 'fw-bold' : '']">{{
                                                        notification.subject
                                                    }}</v-list-tile-title>
                                                    <v-list-tile-sub-title>{{ notification.date_created }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                                <!-- <v-list-tile-action>
                                                    <v-icon
                                                        :color="
                                                            notification.read_flag == 1
                                                                ? selectedNotification && selectedNotification.notification_id == notification.notification_id
                                                                    ? 'white'
                                                                    : '#ddd'
                                                                : ''
                                                        "
                                                        >{{ notification.read_flag == 0 ? "markunread" : "drafts" }}</v-icon
                                                    >
                                                </v-list-tile-action> -->
                                            </v-list-tile>
                                        </template>
                                    </vue-perfect-scrollbar>
                                </v-list>
                                <bc-pagination :page="page" :params="axiosParams" name="me-notifications"></bc-pagination>
                            </v-card-text>
                            <v-divider vertical inset></v-divider>
                        </v-flex>

                        <v-flex xs12 lg9 :style="{ height: 'calc(100vh - 335px)' }">
                            <h1 style="color: #ddd; align-self: center; justify-self: center" v-if="selectedNotification == null">
                                {{ notifications.length > 0 ? $t("lang.view_notification") : "" }}
                            </h1>
                            <v-card-text v-else class="pa-0">
                                <v-container grid-list-md>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-layout row wrap>
                                                <v-flex xs12 lg9>
                                                    <v-text-field v-model="selectedNotification.subject" label="Subject" hide-details readonly></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 lg3>
                                                    <v-text-field v-model="selectedNotification.date_created" label="Date Sent" readonly></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12>
                                            <!-- <v-textarea
                                                v-html="selectedNotification.message"
                                                :label="`${$t('lang.message')}`"
                                                hide-details
                                                scroll
                                                rows="32"
                                                readonly
                                                style="border-color: #dddd"
                                                outline
                                            ></v-textarea> -->
                                            <vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : 'height: calc(100vh - 340px)'">
                                                <div v-html="selectedNotification.message"></div>
                                            </vue-perfect-scrollbar>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-flex>
                    </v-layout>
                    <!-- <v-timeline dense clipped v-if="notifications && notifications.length > 0">
                        <v-timeline-item
                            v-for="(notification, index) in notifications"
                            :key="index"
                            :color="notification.icon_class"
                            :icon="notification.icon"
                            icon-color="white"
                            fill-dot
                        >
                            <v-layout justify-space-between>
                                <v-flex xs12 md9>
                                    <v-flex pa-0 class="fw-bold subheading">{{ notification.subject }}</v-flex>
                                    <v-flex pa-0><div v-html="notification.message"></div></v-flex>
                                    <v-divider v-if="$bp.smAndDown"></v-divider>
                                    <v-flex v-if="$bp.smAndDown" :pl-0="$bp.smAndDown" v-html="notification.date_created"></v-flex>
                                </v-flex>
                                <v-flex md3 text-xs-right class="my-auto" v-html="notification.date_created" v-if="$bp.mdAndUp"></v-flex>
                            </v-layout>
                        </v-timeline-item>
                    </v-timeline>
                    <div
                        v-else
                        class="blue-grey--text text--lighten-4 display-1"
                        :style="$bp.smallScreen ? 'margin-top:16px;' : 'height:calc(80vh - 250px)'"
                        style="width: 100%; display: flex; justify-content: center; align-items: center"
                    >
                        {{ component_loader ? $t("lang.loading") : $t("lang.no_notifications") }}
                    </div> -->
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
    name: "notifications",
    props: ["person"],
    data() {
        return {
            notifications: [],
            component_loader: false,
            filter: {
                search: "",
                company_id: "",
                module: "projects",
                with_tokens: 1,
                status: true,
            },
            selectedNotification: null,
        };
    },
    activated() {
        if (this.notifications.length == 0) {
            this.getNotifications();
        }
    },
    computed: {
        ...mapState({
            page: (state) => state.notifications.notifications_page,
            rules_notifications: (state) => state.notifications.rules_notifications,
        }),
        axiosParams() {
            const params = new URLSearchParams();
            params.append("people_id", this.person.people_id);
            return params;
        },
    },
    methods: {
        ...mapActions(["fetchNotifications", "saveNotification", "deleteNotification", "fetchMeNotifications", "fetchPeople"]),
        getNotifications() {
            let body = { people_id: this.person.people_id };
            this.component_loader = true;
            this.$store
                .dispatch("fetchNotifications", {
                    url: "notifications",
                    method: "get",
                    body: body,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.notifications = data.notifications;
                    }
                })
                .finally(() => {
                    this.component_loader = false;
                });
        },
        selectNotification(notification) {
            this.selectedNotification = { ...notification };
            // if (this.selectedNotification.read_flag == 0) {
            //     this.$nextTick(() => {
            //         this.selectedNotification.read_flag = 1;
            //         let body = this.prepForm(this.selectedNotification, this.rules_notifications);
            //         this.saveNotification({
            //             body: body,
            //         }).then((data) => {
            //             if (data && data.code == "200") {
            //                 this.getNotifications();
            //             } else {
            //                 this.toggleModalLoader(false);
            //             }
            //         });
            //     });
            // }
        },
    },
};
</script>
<style>
.v-list-title > .v-list__tile {
    height: 48px !important;
}

.theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot {
    border-color: #ddd !important;
}
</style>
